import { notification } from 'antd';
import { forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationTypes } from '../../types';

interface Props {
  redirectUrl?: string;
}

const NotificationAlert = forwardRef(({ redirectUrl }: Props, ref) => {
  const [api, contextHolder] = notification.useNotification();
  const navigate = useNavigate();

  const call = (type: NotificationTypes, message?: string) => {
    api[type]({
      key: 'updatable',
      message:
        type === 'success'
          ? message || 'Success'
          : type === 'error'
            ? message || 'Something went wrong.'
            : '',
      placement: 'top',
    });

    if (redirectUrl) {
      setTimeout(() => {
        navigate(redirectUrl);
      }, 1200);
    }
  };

  useImperativeHandle(ref, () => ({
    call,
  }));

  return <>{contextHolder}</>;
});

export default NotificationAlert;
